export default __webpack_public_path__ + "static/media/table-green-raffle.0a524458.png";